import { activityMeasureTagSchema } from './activity-measure-tag.js';
import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
export const activityMeasureSchema = z.object({
    label: z.string(),
    dataType: z.enum(['money', 'time', 'number']),
    unit: z.string(),
    tags: z.array(activityMeasureTagSchema).nullish().transform(nullishToUndefined).optional(),
    value: z.number().nullish().transform(nullishToUndefined).optional(),
});
export function toActivityMeasure(measure) {
    const result = activityMeasureSchema.safeParse(measure);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid ActivityMeasure object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=activity-measure.js.map